const settings = {
    requiredClass: ".gfield_required",
    requiredText: " (obligatoire)"
}

const setRequiredText = () => {
    const requiredFields = document.querySelectorAll(settings.requiredClass);
    if (requiredFields) {
        requiredFields.forEach(field => {
            field.innerHTML = settings.requiredText;
        });
    }
}

$(document).on('gform_post_render', () => {
    setRequiredText();
})
